export const updateDatiPremio = (unDato, unActionType) => {
  return {
    type: unActionType,
    unDato,
  }
};
